import { Space, Typography } from "antd";
import { FC } from "react";
import { UserOutlined } from "@ant-design/icons";
import { useTheme } from "../../../../Styles/ThemeHook";

interface GuestsTagProps {
	guests: number;
	icon?: boolean;
	isEspecial?: Boolean;
}

export const GuestsTag: FC<GuestsTagProps> = ({ guests, icon = false, isEspecial }) => {
	const { theme } = useTheme();

	return (
		<Space size={theme.spacing.smSpacing}>
			{isEspecial ? (
				<>
					{icon && <UserOutlined className="icon" />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							Huésped
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{guests}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <UserOutlined style={{ color: theme.colors.textSecondaryColor }} />}
					<Typography.Text ellipsis>
						{guests} Huéspedes
					</Typography.Text>
				</>
			)}
		</Space>
	);
};
